@if (section(); as s) {
  <app-section-wrapper
    [id]="s.id"
    [title]="s.title"
    [subtitle]="s.subtitle"
    [background]="s.background"
  >
    <div class="supervision-grid stagger">
      @for (pkg of s.items; track pkg.name) {
        <div class="supervision-card" [class.supervision-card--highlight]="pkg.highlight">
          @if (pkg.highlight) {
            <div class="supervision-card__badge">{{ s.highlightBadge }}</div>
          }
          <h3 class="supervision-card__name">{{ pkg.name }}</h3>
          @if (pkg.price) {
            <p class="supervision-card__price">{{ pkg.price }}</p>
          }
          <p class="supervision-card__desc">{{ pkg.description }}</p>
          <ul class="supervision-card__list">
            @for (item of pkg.items; track item) {
              <li>
                <mat-icon>check_circle</mat-icon>
                <span>{{ item }}</span>
              </li>
            }
          </ul>
        </div>
      }
    </div>

    <div class="supervision-cta">
      <app-cta-button
        [label]="s.cta.label"
        variant="primary"
        [fragment]="s.cta.fragment"
      />
    </div>
  </app-section-wrapper>
}
